var exports = {
  "kL": "x61f99309--a41b94--container",
  "W2": "x61f99309--a41b94--scroll",
  "DD": "x61f99309--a41b94--title",
  "wx": "x61f99309--a41b94--header",
  "l3": "x61f99309--a41b94--back_button",
  "Dk": "x61f99309--a41b94--title__fixed",
};

module.exports = exports;
